import { Container, OrkaLogo, OrkaTwoLogo, Typography } from '@evocolabs/orkaui'

/* eslint-disable react/jsx-max-depth */
import { Box } from '@mui/material'
import { SectionTitle } from '../../title'
import TickCircleFill24 from '@evocolabs/icons/lib/TickCircleFill24'
import hearingAidFeatures from './OrkaTwoComparisonData'
import pageStyles from '../styles.module.scss'
import styles from './styles.module.scss'

const data = {
  title: 'Cutting-Edge Hearing Solutions Compared'
}

function QualityWithLowPriceTitle() {
  return (
    <Box className={styles['title-section']} id="quality-title">
      <Box className={styles['navigation-section']}>
        <Typography variant="t1">Features</Typography>
      </Box>
      <Box className={styles['orkatwo-section']}>
        <Box className={styles['logo-section']}>
          <OrkaLogo />
          <OrkaTwoLogo />
        </Box>
      </Box>
      <Box className={styles['traditional-hearing-aids-section']}>
        <Box>
          <Typography variant="subtitle1">Traditional Hearing Aids</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle1">(Premium)</Typography>
        </Box>
      </Box>
    </Box>
  )
}

function QualityWithLowPriceComparison() {
  return (
    <Box className={styles['comparison-section']} id="quality-comparison">
      {hearingAidFeatures.map(({ featureName, orkaTwo, traditionalHA }) => {
        return (
          <Box key={featureName} className={styles['comparison-item']}>
            <Box className={styles['comparison-feature-name-section']}>
              <Typography variant="body1">{featureName}</Typography>
            </Box>
            <Box className={styles['comparison-orkatwo-section']}>
              <TickCircleFill24
                size="42px"
                forceFill={orkaTwo ? '#008A5E' : '#B8B6B5'}
              />
            </Box>
            <Box
              className={styles['comparison-traditional-hearing-aids-section']}
            >
              <TickCircleFill24
                size="32px"
                forceFill={traditionalHA ? '#008A5E' : '#B8B6B5'}
              />
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

function QualityWithLowPriceReason() {
  return (
    <Box className={styles['reason-section']} id="quality-reason">
      <Box className={styles['reason-journey-section']}>
        <Box className={styles['reason-price-navigation-section']}>
        </Box>
        <Box className={styles['reason-price-orkatwo-section']}>
        </Box>
        <Box
          className={styles['reason-price-traditional-hearing-aids-section']}
        >
        </Box>
      </Box>
    </Box>
  )
}

function QualityWithLowPriceSection() {
  return (
    <Container className={pageStyles.section}>
      <SectionTitle>{data.title}</SectionTitle>
      <Box width="100%">
        <QualityWithLowPriceTitle />
        <QualityWithLowPriceComparison />
        <QualityWithLowPriceReason />
      </Box>
    </Container>
  )
}

export default QualityWithLowPriceSection
